import { withCurrentParams } from 'actions/utils';
import { BROADCAST_CREATE_LIVE_RECORDING } from 'actions/Types';
import { BROADCAST_RECORDING_CREATE } from 'store/eventConstants';

/**
 * Create a live recording
 *
 * @param {*} recording
 */
export default recording => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        meeting: { attendeeResponse }
      } = getState();
      const action = {
        type: BROADCAST_CREATE_LIVE_RECORDING,
        request: async apiClient => {
          const resp = await apiClient.broadcast.createRecording(
            teamId,
            eventId,
            broadcastId,
            recording
          );
          // notify other directors
          socket.emit(BROADCAST_RECORDING_CREATE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          return resp;
        }
      };
      dispatch(action);
    }
  );
};
